import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
// import { TraceUpdateComponent } from 'src/app/views/appviews/trace-update/trace-update.component';
// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay, map } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';

import { Brand } from './../../api/brand';
import { BsModalRef, BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { GlobalFunctionsService } from './../../services/global-functions.service';
// import { CompanyEditComponent } from './../../../ company-edit/company-edit.component';
@Component({
  selector: 'app-agent-invoices',
  templateUrl: './agent-invoices.component.html',
  styleUrls: ['./agent-invoices.component.scss']
})
export class AgentInvoicesComponent implements OnInit {
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  constructor(
    private http: HttpClient, private router: Router, private route: ActivatedRoute, private _demoService: DemoService,
    public datepipe: DatePipe, private _location: Location,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) {

 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   }

  ngOnInit(): void {
  }

}
